<template>
  <div style="">
      <w-dropdown-with-search-table
        class="py-0 px-3 ml-n1"
        :searchedDefaultValue="searchedParentName"
        :searchSource="searchSource"
        :searchPlaceholder="'min 5 characters- PI Number,PAN,Vendor name/code'"
        @searchAutoCompleEvent="getSearchTerm($event)"
        @getFieldEvent="getFieldsSelected($event)"
        :searchLoading="searchLoading"
        :noResultMessage="'No partners found'"
      />
  </div>
</template>

<script>
import { SummaryServices } from "../services/summaryService";
import DropdownWithSearchTable from "../widgets/dropDownWithInlineSearchEmp";
const SummaryService = new SummaryServices();

export default {
  components: {
    "w-dropdown-with-search-table": DropdownWithSearchTable
  },
  data() {
    return {
      vendorList: [],
      searchSource: [],
      searchedParentName: "",
      catchTextMessage: "", 
      searchLoading: false,
      partnerID: 0,
      partnerNumber:"",
      getPartnerIdArray: [],
      isRedirectFromPOB: false
      // selectedVendor: ""
    };
  },
  created() {
    // this.getEmpaneledVendorList();
    var self = this
    EventBus.$on('resetSearch',function(){
      self.searchedParentName=''
      self.$forceUpdate();
    })
    if(sessionStorage.getItem("redirectFrom") === 'pobwf'){
      this.searchLoading = true; 
      this.isRedirectFromPOB = true
      this.searchedParentName = sessionStorage.getItem("piNo") ? sessionStorage.getItem("piNo") : ''
    }
    
  },
  watch: {
    searchedParentName: function(newval,oldval) {
      if(this.isRedirectFromPOB){
        this.getSearchTerm(newval)
      }
    }
  },
  methods: {
    getSearchTerm(event) {
      event = event.trim();
      if (event.length > 4) {
        this.searchLoading = true;
        let searchData = {
          input: event
        };
        SummaryService.
        getPartnerSuggestion(searchData)
          .then(res => {
            if (res.failureMessage == "" || !res.failureMessage) {
              this.searchSource = [];
              this.searchLoading = false;
              console.log("Auto Dropdown Text", res);
              res.forEach((element, index) => {
                this.searchSource[index] =
                  element.partnerNumber + "-" + element.longDesc + "-"
                  + (element.oldPartnerNumber ? ("-" +  element.oldPartnerNumber): '') 
                   + (element.idCardValue ? ("-" +  element.idCardValue): '') 
                   +  '-' + event;
                this.getPartnerIdArray[index] = element;
              });
            }
            
          EventBus.$emit("Partnerlist", res);
            //this.getFieldsSelected(this.searchSource[0])
          })
          .catch(err => {
            this.searchLoading = false;
            console.log(err);
          });
      } else {
        this.searchLoading = false;
        this.searchSource = [];
      }
    },
    getFieldsSelected(event) {
      if (event != "") {
        if(event != undefined){
        this.searchedParentName = event;
        }
        sessionStorage.setItem("partnerSelectedValue", this.searchedParentName);
        this.getPartnerIdArray.forEach((element, i) => {
          if (element.partnerNo + "-" + element.longDesc == event) {
            this.partnerID = element.partnerId;
            this.partnerNumber = element.partnerNo
          }
        });
        sessionStorage.setItem("selectedVendor", this.partnerID);
        
        EventBus.$emit("partnerSelected", this.searchedParentName);
        if(this.isRedirectFromPOB){
        this.submitSelectedVendor();
        } else {
        sessionStorage.setItem("NonWFpemPiNo", this.partnerNumber);
        }
      }
    },
    // getEmpaneledVendorList() {
    //   this.$emit("loadingStatusTrue");
    //   empanelmentService
    //     .getEmpaneledVendorList()
    //     .then(res => {
    //       this.$emit("loadingStatusfalse");
    //       console.log(res);
    //       // this.vendorList.push({
    //       //   text: "Select Partner",
    //       //   value: "",
    //       //   disabled: true
    //       // });
    //       res.response.forEach(element => {
    //         this.vendorList.push({
    //           text: element.partnerNo + "-" + element.longDesc,
    //           value: element.partnerId
    //         });
    //       });
    //     })
    //     .catch(error => {
    //       console.log("catch Error", error);
    //       this.$emit("loadingStatusfalse");
    //     });
    // },
    // getSelectedVendor(event) {
    //   this.selectedVendor = event;
    //   sessionStorage.setItem(
    //     "selectedVendor",
    //     JSON.stringify(this.selectedVendor)
    //   );
    // },
    submitSelectedVendor(event) {
      this.$router.push({
        name: "Empanelment-List",
        params: { selectedVendor: this.partnerID }
      });
    }
  }
};
</script>

<style scoped>
.hr_class {
  width: 95%;
  margin-left: 2%;
}
.card-class {
  /* width: 650.2px; */
  height: 229.1px;
  border-radius: 3px;
  border: solid 1px #cbd5dd;
  background-color: #ffffff;
}
.request-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
}
</style>
